import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@src/redux/store.ts'

const initialState: any = {
  motionStatus: 'IDLE', // 'IDLE', 'GRANTED', 'REJECTED'
  cameraStatus: 'IDLE', // 'IDLE', 'GRANTED', 'REJECTED'
  gpsStatus: 'IDLE', // 'IDLE', 'GRANTED', 'REJECTED',
  cameraDeviceId: null, // 선택된 카메라 장치 ID
  alphaOffset: 0,
}

const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    initStatus: (state) => {
      Object.assign(state, initialState)
    },
    motionGranted: (state) => {
      state.motionStatus = 'GRANTED'
    },
    motionDenied: (state) => {
      state.motionStatus = 'REJECTED'
    },
    webcamGranted: (state) => {
      state.cameraStatus = 'GRANTED'
    },
    webcamDenied: (state) => {
      state.cameraStatus = 'REJECTED'
    },
    gpsGranted: (state) => {
      state.gpsStatus = 'GRANTED'
    },
    gpsDenied: (state) => {
      state.gpsStatus = 'REJECTED'
    },
    setCameraDeviceId: (state, action) => {
      state.cameraDeviceId = action.payload
    },
    setAlphaOffsetAction: (state, action) => {
      state.alphaOffset = action.payload
    },
  },
})

export const {
  initStatus,
  motionGranted,
  motionDenied,
  webcamGranted,
  webcamDenied,
  gpsGranted,
  gpsDenied,
  setCameraDeviceId,
  setAlphaOffsetAction,
} = deviceSlice.actions

export const deviceSelector = (state: RootState) => state.device

export default deviceSlice.reducer
